import React from 'react';
import i18next from 'i18next';
import { useTranslation, withTranslation } from 'react-i18next';
import { Box, Grid, Typography, Container, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import compose from 'ramda/src/compose';
import LocaleKeys from '../../locales/keys';
import WarningIcon from '@material-ui/icons/Warning';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  section: {
    backgroundColor: theme.palette.custom.containerBG,
    borderRadius: '8px',
  },
  image404: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

function ErrorPage() {
  const history = useHistory();
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Box className={classes.section} pl={8} pr={8} pb={8} pt={8}>
          <Box component={Grid} container>
            <Box component={Grid} item xs={12}>
              <Box mt={3} className={classes.image404}>
                <WarningIcon />
              </Box>
            </Box>
            <Box component={Grid} item xs={12}>
              <Box mt={3}>
                <Typography variant="h4" align="center" color="textPrimary">
                  <strong>{t(LocaleKeys.retention.errorDialogTitle)}</strong>
                </Typography>
              </Box>
            </Box>
            <Box component={Grid} item xs={12}>
              <Typography variant="body1" align="center" color="textPrimary">
                {i18next.t(`${LocaleKeys.fault_prefix}0`)}
              </Typography>
            </Box>
            <Box component={Grid} item xs={12}>
              <Box mt={6} align="center">
                <Button
                  variant="outlined"
                  color="primary"
                  disableRipple
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  {t(LocaleKeys.registration.back)}
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default compose(withTranslation())(ErrorPage);
